import React from 'react';
import { IBudgetItem } from '../../blueprint';
import TableRow from './table-row';

interface RevenuesTableProps {
  revenues: any;
  remove: (item: IBudgetItem) => void;
}

export default function RevenuesTable({
  revenues,
  remove,
}: RevenuesTableProps) {
  return revenues ? (
    <>
      <TableRow key={`row-${revenues.name}-${+new Date()}`} item={revenues} />
      {revenues &&
        revenues.children &&
        revenues.children.map((revenue: any) => (
          <TableRow
            key={`row-${revenue.name}`}
            item={revenue}
            remove={remove}
          />
        ))}
    </>
  ) : null;
}
